import { useFormikContext } from "formik";
import { CURRENT_COVERAGE_FORM } from "pages/PreQualification/utils/constants";
import { CurrentCoverageFormType } from "pages/PreQualification/utils/formTypes";
import { healthCarrierOptions } from "pages/PreQualification/utils/selectHelper";
import React, { useEffect } from "react";
import DateInput from "uicomponents/DateInput";
import RadioInput from "uicomponents/RadioInput";
import SelectInput from "uicomponents/SelectInput";
import TextInput from "uicomponents/TextInput";

interface ICurrentCoverageComponentProps {
  data?: any;
}

const CurrentCoverageComponent = ({
  ...props
}: ICurrentCoverageComponentProps): JSX.Element => {
  const { values, setFieldValue } = useFormikContext();

  const lableList = CURRENT_COVERAGE_FORM.QUESTIONS;
  const messageList = CURRENT_COVERAGE_FORM.MESSAGE;

  const hasHealthInsurance = (values as CurrentCoverageFormType)
    ?.currentlyOfferHealthInsurance;
  const hasCobraInsurance = (values as CurrentCoverageFormType)?.cobraUsage;
  const hasOtherCarier = (values as CurrentCoverageFormType)?.currentCarrier;

  useEffect(() => {
    if (hasHealthInsurance === "No") {
      const updateFieldList = [
        "currentCarrier",
        "currentRenewalDate",
        "cobraUsage",
        "cobraUsers",
        "benefitEligibleEmployees",
        "currentCarrierOther",
      ];
      updateFieldList.forEach((field) => {
        setFieldValue(field, "");
      });
    }
  }, [hasHealthInsurance, setFieldValue]);

  useEffect(() => {
    if (hasCobraInsurance === "No") {
      const updateFieldList = ["cobraUsers", "benefitEligibleEmployees"];
      updateFieldList.forEach((field) => {
        setFieldValue(field, "");
      });
    }
  }, [hasCobraInsurance, setFieldValue]);

  useEffect(() => {
    if (hasOtherCarier !== "OTHER") {
      setFieldValue("currentCarrierOther", "");
    }
  }, [hasOtherCarier, setFieldValue]);
  return (
    <div>
      <RadioInput
        name="currentlyOfferHealthInsurance"
        label={lableList.currentlyOfferHealthInsurance}
        options={["Yes", "No"]}
      />
      {hasHealthInsurance === "Yes" && (
        <>
          <SelectInput
            name="currentCarrier"
            options={healthCarrierOptions}
            label={lableList.currentCarrier}
            placeholder="Select an option"
          />
          {hasOtherCarier === "OTHER" && (
            <TextInput
              name="currentCarrierOther"
              label={lableList.currentCarrierOther}
            />
          )}
          <DateInput
            name="currentRenewalDate"
            label={lableList.currentRenewalDate}
          />
          <RadioInput
            name="cobraUsage"
            label={lableList.cobraUsage}
            options={["Yes", "No"]}
          />
          {hasCobraInsurance === "Yes" && (
            <>
              <TextInput name="cobraUsers" label={lableList.cobraUsers} />
              <TextInput
                name="benefitEligibleEmployees"
                label={lableList.benefitEligibleEmployees}
                message={messageList.benefitEligibleEmployees}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default CurrentCoverageComponent;
